import { featureFlagService } from '@superbet-group/web.lib.flags';
import { ActionContext } from 'vuex';

import { SportOfferFeatureFlag } from './SportOfferFeatureFlag';

type SportOfferExperimentsState = {
    isCombinableMarketGroupEnabled: boolean;
    isShowingSuperBonusForAnySelectionCount: boolean;
    isSuperAdvantagePageEnabled: boolean;
    isPerLegSettlementStatusEnabled: boolean;
};

const SET_IS_COMBINABLE_MARKET_GROUP_ENABLED = 'SET_IS_COMBINABLE_MARKET_GROUP_ENABLED';
const SET_IS_SHOWING_SUPER_BONUS_FOR_ANY_SELECTION_COUNT = 'SET_IS_SHOWING_SUPER_BONUS_FOR_ANY_SELECTION_COUNT';
const SET_IS_SUPER_ADVANTAGE_PAGE_ENABLED = 'SET_IS_SUPER_ADVANTAGE_PAGE_ENABLED';
const SET_IS_PER_LEG_SETTLEMENT_STATUS_ENABLED = 'SET_IS_PER_LEG_SETTLEMENT_STATUS_ENABLED';

function getDefaultState(): SportOfferExperimentsState {
    return {
        isCombinableMarketGroupEnabled: false,
        isShowingSuperBonusForAnySelectionCount: false,
        isSuperAdvantagePageEnabled: false,
        isPerLegSettlementStatusEnabled: true,
    };
}

export const sportOfferExperimentsStore = {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        isCombinableMarketGroupEnabled: (state: SportOfferExperimentsState) => state.isCombinableMarketGroupEnabled,
        isShowingSuperBonusForAnySelectionCount: (state: SportOfferExperimentsState) => state.isShowingSuperBonusForAnySelectionCount,
        isSuperAdvantagePageEnabled: (state: SportOfferExperimentsState) => state.isSuperAdvantagePageEnabled,
        isPerLegSettlementStatusEnabled: (state: SportOfferExperimentsState) => state.isPerLegSettlementStatusEnabled,
    },

    mutations: {
        [SET_IS_COMBINABLE_MARKET_GROUP_ENABLED]: (state: SportOfferExperimentsState, isCombinableMarketGroupEnabled: boolean) => {
            state.isCombinableMarketGroupEnabled = isCombinableMarketGroupEnabled;
        },
        [SET_IS_SHOWING_SUPER_BONUS_FOR_ANY_SELECTION_COUNT]: (state: SportOfferExperimentsState, isShowingSuperBonusForAnySelectionCount: boolean) => {
            state.isShowingSuperBonusForAnySelectionCount = isShowingSuperBonusForAnySelectionCount;
        },
        [SET_IS_SUPER_ADVANTAGE_PAGE_ENABLED]: (state: SportOfferExperimentsState, isSuperAdvantagePageEnabled: boolean) => {
            state.isSuperAdvantagePageEnabled = isSuperAdvantagePageEnabled;
        },
        [SET_IS_PER_LEG_SETTLEMENT_STATUS_ENABLED]: (state: SportOfferExperimentsState, isPerLegSettlementStatusEnabled: boolean) => {
            state.isPerLegSettlementStatusEnabled = isPerLegSettlementStatusEnabled;
        },
    },

    actions: {
        trackSportOfferExperiments: (context: ActionContext<SportOfferExperimentsState, unknown>) => {
            const {
                isCombinableMarketGroupEnabled,
                isShowingSuperBonusForAnySelectionCount,
                isSuperAdvantagePageEnabled,
                isPerLegSettlementStatusEnabled,
            } = getDefaultState();

            featureFlagService.subscribeToFeatureChanges(SportOfferFeatureFlag.CombinableMarketGroup, (isEnabled: boolean) => {
                context.commit(SET_IS_COMBINABLE_MARKET_GROUP_ENABLED, isEnabled);
            }, isCombinableMarketGroupEnabled);
            featureFlagService.subscribeToFeatureChanges(SportOfferFeatureFlag.SuperBonusForAnySelectionCount, (isEnabled: boolean) => {
                context.commit(SET_IS_SHOWING_SUPER_BONUS_FOR_ANY_SELECTION_COUNT, isEnabled);
            }, isShowingSuperBonusForAnySelectionCount);
            featureFlagService.subscribeToFeatureChanges(SportOfferFeatureFlag.SuperAdvantagePage, (isEnabled: boolean) => {
                context.commit(SET_IS_SUPER_ADVANTAGE_PAGE_ENABLED, isEnabled);
            }, isSuperAdvantagePageEnabled);
            featureFlagService.subscribeToFeatureChanges(SportOfferFeatureFlag.PerLegSettlementStatus, (isEnabled: boolean) => {
                context.commit(SET_IS_PER_LEG_SETTLEMENT_STATUS_ENABLED, isEnabled);
            }, isPerLegSettlementStatusEnabled);
        },
    },
};

export type SportOfferExperimentsStore = typeof sportOfferExperimentsStore;
